export const TableModifier = {
  XXSWIDTH: (type: string) => `${type}--xxs-width`,
  XSWIDTH: (type: string) => `${type}--xs-width`,
  SWIDTH: (type: string) => `${type}--s-width`,
  MWIDTH: (type: string) => `${type}--m-width`,
  LWIDTH: (type: string) => `${type}--l-width`,
  XLWIDTH: (type: string) => `${type}--xl-width`,
  WIDTH_140: (type: string) => `${type}--width-140`,
  WIDTH_33_100: (type: string) => `${type}--width-33-100`,
  NOPADDING: (type: string) => `${type}--no-padding`,
  LOWPADDING: (type: string) => `${type}--lowpadding`,
  DARKBORDER: (type: string) => `${type}--dark-border`,
  VERTICAL_TOP: (type: string) => `${type}--vertical-top`,
  VERTICAL_CENTER: (type: string) => `${type}--vertical-center`,
};

export enum CellRole {
  ROW_HEADER = 'rowheader',
  COLUMN_HEADER = 'columnheader',
}

export enum CellScope {
  COLUMN = 'col',
  ROW = 'row',
}
